import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { SearchRound, SearchRoundsModel } from '../../types';
import { AbstractModel } from '@patsnap/tahiti-core';

@injectable()
export class SearchRoundsModelImpl extends AbstractModel<SearchRound[]> implements SearchRoundsModel {
    protected _modelData: SearchRound[] = [];
}
